import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import {
    ConfigurationAutomaticBillableConceptRuleCreateRequest,
    ConfigurationAutomaticBillableConceptRulePatchInBatchRequest,
    ConfigurationAutomaticBillableConceptRuleResponse
} from '@/modules/configurationModule/detail/automation/billable-concepts/components/services/configuration-automatic-billable-concept/configuration-automatic-billable-concept-rule.dto'

class ConfigurationAutomaticBillableConceptRuleService {
    async create(laboratoryId: number, request: ConfigurationAutomaticBillableConceptRuleCreateRequest): Promise<ConfigurationAutomaticBillableConceptRuleResponse> {
        const response = await axios.post<ConfigurationAutomaticBillableConceptRuleResponse>(`/configuration/laboratories/${laboratoryId}/automaticBillableConceptRules`, request)
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationAutomaticBillableConceptRuleResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationAutomaticBillableConceptRuleResponse>>(`/configuration/laboratories/${laboratoryId}/automaticBillableConceptRules`, { ...filterModel }, { params })
        return response.data
    }

    async get(automaticBillableConceptRuleId: number, laboratoryId: number): Promise<ConfigurationAutomaticBillableConceptRuleResponse> {
        const response = await axios.get<ConfigurationAutomaticBillableConceptRuleResponse>(`/configuration/laboratories/${laboratoryId}/automaticBillableConceptRules/${automaticBillableConceptRuleId}`)
        return response.data
    }

    async delete(laboratoryId: number, request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/automaticBillableConceptRules/batch`, { data: request })
        return response.data
    }

    async patch(laboratoryId: number, request: ConfigurationAutomaticBillableConceptRulePatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/automaticBillableConceptRules/batch`, request)
        return response.data
    }
}

export const configurationAutomaticBillableConceptRuleService = new ConfigurationAutomaticBillableConceptRuleService()
